import React from 'react';
import PropTypes from 'prop-types';

import guid from '@/shared/utils/guid';
import UserSearch from './UserSearch';

const RelationUserSearch = ({ value = null, onChange, withUnassigned = true, withCurrentUser = true, ...rest }) => (
  <UserSearch
    onChange={user => onChange(user ? user.id : null)}
    value={value}
    withUnassigned={withUnassigned}
    unassignedId={guid.empty}
    withCurrentUser={withCurrentUser}
    {...rest}
  />
);

RelationUserSearch.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  withUnassigned: PropTypes.bool,
  withCurrentUser: PropTypes.bool,
};

export default RelationUserSearch;
